import { render, staticRenderFns } from "./HotelPage.vue?vue&type=template&id=f63efc2c&"
import script from "./HotelPage.vue?vue&type=script&lang=ts&"
export * from "./HotelPage.vue?vue&type=script&lang=ts&"
import style0 from "./HotelPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports